import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { 
  IconButton, 
  Typography } from "@mui/material";
import SearchTextField from "../../components/SearchTextField/SearchTextField";
import PartnerTable from "../../components/BasicTable/BasicTable";
import Pagination from "../../components/Pagination/Pagination";
import routes from "../../react_routes_enum";
import DoDisturbIcon from '@mui/icons-material/DoDisturb';
import Spinner from "../../components/Spinner/Spinner";
import VisibilityIcon from '@mui/icons-material/Visibility';
import { toast } from "react-toastify";
import { 
    getLeads,
    getLeadById,
    leadStatusUpdate
  } from "../../redux/lgs/lgsSlice";

const LeadRejected = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  // Pagination Required parameters
  const [limit, setLimit] = useState(10);
  const [offset, setOffset] = useState(0);
  const [page, setPage] = useState(0);
  const colR = ["SNo", "Name", "Phone Number", "Email ID", "Status", "actions"];

  const { 
    isLoading,
    isError, 
    message,
    totalCount,
    searchText,
    leadData } = useSelector(
    (state) => state.lead
  );

  useEffect(() => {
    const res = dispatch(getLeads({ limit, offset, searchText, status: "rejected" }));
    res?.then((r) => {
      if(r?.payload?.message.toLowerCase() === "unauthorized" || 
        r?.payload?.message === "Session Expired"){
        toast.error("Session expired, please login again");
        localStorage.removeItem("hp_token");
        localStorage.removeItem("hp_user");
        navigate(routes.LOGIN);
      }
    })
  }, [limit, offset]);

  const resetStateForPaginationOfDifferentView = () => {
    setLimit(10);
    setOffset(0);
    setPage(0);
  };

  const handleSearchText = (e) => {
    resetStateForPaginationOfDifferentView();
    if (limit === 10 && offset === 0) {
      const res = dispatch(getLeads({ limit, offset, searchText, status: "rejected" }));
      res?.then((r) => {
        if(r?.payload?.message.toLowerCase() === "unauthorized" || 
          r?.payload?.message === "Session Expired"){
          toast.error("Session expired, please login again");
          localStorage.removeItem("hp_token");
          localStorage.removeItem("hp_user");
          navigate(routes.LOGIN);
        }
      })
    }
  };

  const viewDetail = (id) => {
    const res = dispatch(getLeadById({id}));
    res?.then((r) => {
      if(r?.payload?.statusCode === 200){
        navigate(routes.LEAD_DETAIL)
      }else{
        if(r?.payload?.message.toLowerCase() === "unauthorized" || 
          r?.payload?.message === "Session Expired"){
          toast.error("Session expired, please login again");
          localStorage.removeItem("hp_token");
          localStorage.removeItem("hp_user");
          navigate(routes.LOGIN);
          return;
        }
        toast.error(r?.payload?.message);
      }
    })
  }
 
  if (isLoading) return <Spinner />;
  if (isError) return <h1>{message}</h1>;
  
  const unDoReject = (id, from) => {
    const res = dispatch(leadStatusUpdate({id, from, status: "pending"}));
    res.then((r) => {
        if(r.payload.statusCode === 200){
          toast.success("LGS Sent To Pending List");
          dispatch(getLeads({ limit, offset, searchText, status: "rejected" }));
        }else{
          if(r?.payload?.message.toLowerCase() === "unauthorized" || 
            r?.payload?.message === "Session Expired"){
            toast.error("Session expired, please login again");
            localStorage.removeItem("hp_token");
            localStorage.removeItem("hp_user");
            navigate(routes.LOGIN);
            return;
          }
          toast.error(r?.payload?.message);
        }
    })
  }
  return (
    <>
      <div style={{marginTop: '3%'}}>
        <SearchTextField
          searchText={searchText}
          handleSearchText={handleSearchText}
          fromWhere="lead"
        />
        <div className="pagination-addPost">
          <Pagination
            totalCount={totalCount}
            limit={limit}
            page={page}
            changeLimit={setLimit}
            changeOffset={setOffset}
            changePage={setPage}
          />
        </div>
        <PartnerTable
          columns={colR}
          where="recipes"
          rows={leadData && leadData?.map((item) => {
            const res = {
              ...item,
              Status: (
                <Typography component="p" variant="p" 
                sx={{
                    color: '#EF0000',
                    fontSize: '18px',
                    fontWeight: 'bold',
                    }}>
                    Rejected
                </Typography>
              ),
              actions: (
                <div style={{
                  display: 'flex',
                  alignItems: 'center'
                }}>
                  <IconButton
                    color="inherit"
                    edge="start"
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                    }}
                    onClick={() => viewDetail(item?._id)}
                  >
                    <VisibilityIcon sx={{color: '#3C1CDE'}} />
                    <Typography component="p" variant="p" 
                      sx={{
                        color: '#3C1CDE',
                        fontSize: '18px',
                        fontWeight: 'bold',
                        marginTop: '6px'
                        }}>
                      View
                    </Typography>
                  </IconButton>
                  <IconButton
                    color="inherit"
                    edge="start"
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      margin: '0 8px'
                    }}
                    onClick={() => unDoReject(item._id, "approve")}
                  >
                    <DoDisturbIcon sx={{color: '#07AB35'}} />
                    <Typography component="p" variant="p" 
                      sx={{
                        color: '#07AB35',
                        fontSize: '18px',
                        fontWeight: 'bold',
                        marginTop: '6px'
                        }}>
                      Undo
                    </Typography>
                  </IconButton>
                </div>
              )
            };
            return res;
          })}
        />
      </div>
    </>
  );
};

export default LeadRejected;
